export type StatusBadgeColor = {
  bg: string;
  text: string;
};

export type StatusBadgeProps = {
  label: string;
  colorMap: Record<string, StatusBadgeColor>;
  fallback?: StatusBadgeColor;
};

const DEFAULT_FALLBACK: StatusBadgeColor = {
  bg: 'bg-gray-200',
  text: 'text-gray-700',
};

export const StatusBadge = ({
  label,
  colorMap,
  fallback = DEFAULT_FALLBACK,
}: StatusBadgeProps) => {
  const style = colorMap[label] ?? fallback;
  return (
    <span
      className={`rounded px-2 py-1 text-xs font-medium ${style.bg} ${style.text}`}
    >
      {label}
    </span>
  );
};

export const workflowStatusColors: Record<string, StatusBadgeColor> = {
  Validating: { bg: 'bg-purple-500', text: 'text-white' },
  'In Progress': { bg: 'bg-blue-500', text: 'text-white' },
  Issues: { bg: 'bg-yellow-500', text: 'text-white' },
  Complete: { bg: 'bg-green-500', text: 'text-white' },
  Error: { bg: 'bg-red-500', text: 'text-white' },
  'No Data': { bg: 'bg-gray-500', text: 'text-white' },
};

export const statusCellStyle = (
  colorMap: Record<string, StatusBadgeColor>,
  valueFormatter?: (value: any) => string,
) => {
  const bgHexMap: Record<string, string> = {
    'bg-purple-500': '#8b5cf6',
    'bg-blue-500': '#3b82f6',
    'bg-yellow-500': '#eab308',
    'bg-green-500': '#22c55e',
    'bg-red-500': '#ef4444',
    'bg-gray-500': '#64748b',
  };

  return (params: any) => {
    const label = valueFormatter ? valueFormatter(params.value) : params.value;
    const style = colorMap[label];
    if (!style) return {};
    return {
      backgroundColor: bgHexMap[style.bg] ?? style.bg,
      color: 'white',
      padding: '4px 8px',
      borderRadius: '4px',
    };
  };
};
